import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./Appointment.css";

const AppointmentList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const [appointments, setAppointments] = useState([]);
  const [search, setSearch] = useState("");

  /* ================= FETCH DATA ================= */

  const fetchAppointments = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/appointments`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      setAppointments(response.data.data || response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, []);

  /* ================= UPDATE STATUS ================= */

  const updateStatus = async (id, currentStatus) => {
    const newStatus =
      currentStatus === "pending" ? "completed" : "pending";

    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: `Mark as ${newStatus}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Update",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.put(
          `${API_BASE_URL}/admin/appointments/${id}`,
          { appointmentStatus: newStatus },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        Swal.fire("Updated!", "Status updated successfully.", "success");
        fetchAppointments();
      } catch (error) {
        Swal.fire("Error!", "Failed to update status.", "error");
      }
    }
  };

  /* ================= FILTER ================= */

  const filteredAppointments = appointments.filter((item) =>
    item.fullName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="appointment-container">
      <h2 className="page-title">Appointments</h2>

      <input
        type="text"
        placeholder="Search by Name..."
        className="search-input"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="appointment-grid">
        {filteredAppointments.map((item) => (
          <div key={item._id} className="appointment-card">
            <div className="card-header">
              <h3>{item.fullName}</h3>
              <span
                className={`status-badge ${
                  item.appointmentStatus === "pending"
                    ? "pending"
                    : "completed"
                }`}
              >
                {item.appointmentStatus}
              </span>
            </div>

            <div className="card-body">
              <p><strong>Course:</strong> {item.course}</p>
              <p><strong>Duration:</strong> {item.courseDuration}</p>
              <p><strong>Date:</strong> {item.consultancyDate}</p>
              <p><strong>Time:</strong> {item.consultancyTime}</p>
              <p><strong>Mode:</strong> {item.consultancyMode}</p>
              <p><strong>Price:</strong> ₹{item.price}</p>
              <p><strong>Contact:</strong> {item.contactNumber}</p>
              <p><strong>Email:</strong> {item.email}</p>
            </div>

            <button
              className="status-btn"
              onClick={() =>
                updateStatus(item._id, item.appointmentStatus)
              }
            >
              Change Status
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppointmentList;


